import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import chatDetail from "./components/chatDetail";
import { mapActions } from "vuex";
import { getMessagesList, disableUser } from '@/api/auth/onlineUser';
export default {
  name: "analysisChatManagement",
  components: {
    chatDetail: chatDetail
  },
  data: function data() {
    return {
      tableData: [],
      searchData: {
        page: 1,
        page_size: 10
      },
      total: 0
    };
  },
  activated: function activated() {
    this.getData(this.searchData.page);
  },
  methods: {
    getData: function getData(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.searchData.page = e;
                _context.next = 3;
                return getMessagesList(_this.searchData);

              case 3:
                query = _context.sent;
                _this.tableData = query.data.data;
                _this.total = query.data.total;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.getData(1);
    },
    handleDisable: function handleDisable(id) {
      var _this2 = this;

      disableUser({
        id: id
      }).then(function (res) {
        if (res.status == 200) {
          Message({
            message: res.message,
            type: "success"
          });

          _this2.getData(_this2.searchData.page);
        } else {
          Message({
            message: res.message,
            type: "warning"
          });
        }
      });
    }
  }
};